import { put, takeLatest } from 'redux-saga/effects';
import requestWrapper from 'utils/requestWrapper';
// utils
import useDeviceDetect from 'utils/useDeviceDetect';


export default function* mainAppSaga() {
  // See example in containers/HomePage/saga.js
}
